import Component from "./knowledgeBase.component";
import { Config } from "./knowledgeBase.config";
import { watchKnowledgeBase as saga } from "./redux/knowledgeBase.sagas";
import { reducer } from "./redux/knowledgeBase.reducer";

export default { Component, saga, reducer, config: Config };
